import React from 'react'
import { Controller, useFormState } from 'react-hook-form'
import styles from './PhoneField.module.css'

const ActivePhoneField = ({ field, control }) => {
  const { errors, isSubmitted } = useFormState({ control })
  const error = errors[field.idFieldCanvas]
  const input_style = field.input_design ? { ...field.input_design } : {}
  let inputClass = ''

  if (isSubmitted) {
    inputClass = error ? 'input-error' : 'input-success'
  }

  return (
    <Controller
      control={control}
      name={field.idFieldCanvas}
      defaultValue={
        field.VALUE__reponse !== undefined && field.VALUE__reponse !== ''
          ? field.VALUE__reponse
          : null
      }
      rules={{
        required: field.required ? 'Ce champ est requis.' : false,
        validate: (value) => {
          if (!value) {
            // Si le champ n'est pas requis et vide, c'est valide
            return true
          }
          const numDigits = value.replace(/\D/g, '').length
          if (numDigits !== 10) {
            return 'Le numéro de téléphone doit contenir exactement 10 chiffres numériques.'
          }
          const pattern = /^(0\d\s?\d{2}\s?\d{2}\s?\d{2}\s?\d{2})$/
          if (!pattern.test(value)) {
            return 'Le format doit commencer par 0 suivi de 9 chiffres (espaces optionnels).'
          }
          return true
        },
      }}
      render={({ field: fieldProps }) => (
        <div>
          <input
            {...fieldProps}
            type="tel"
            className={inputClass}
            style={input_style || {}}
            placeholder={field.placeholder || ''}
          />
          {error && <p className="error__message">{error.message}</p>}
        </div>
      )}
    />
  )
}

const InactivePhoneField = ({ field }) => {
  const input_style = field.input_design ? { ...field.input_design } : {}
  return (
    <input
      defaultValue={field.VALUE__reponse ? field.VALUE__reponse : ''}
      type="tel"
      style={input_style || {}}
      placeholder={field.placeholder || ''}
    />
  )
}

const PhoneField = ({ field, control, isActiveSubmit }) => {
  return isActiveSubmit ? (
    <ActivePhoneField field={field} control={control} />
  ) : (
    <InactivePhoneField field={field} />
  )
}

export default PhoneField
